import React from "react";
import { Link } from "react-router-dom";
import { FaShieldAlt, FaExternalLinkAlt, FaCheckCircle, FaExclamationCircle } from "react-icons/fa";

const DEFAULT_EVENTS = [
  {
    username: "superadmin",
    module: "Emissiones",
    action: "Emisión de Certificado Catastral",
    date: "Hace 2 minutos",
    status: "Correcto",
  },
  {
    username: "superadmin",
    module: "Interoperabilidad",
    action: "Sync Conector RENAPO",
    date: "Hace 15 minutos",
    status: "Correcto",
  },
  {
    username: "admin_catastro",
    module: "Catastro",
    action: "Consulta de Predio #12049",
    date: "Hace 24 minutos",
    status: "Correcto",
  },
  {
    username: "sistema",
    module: "Monitoreo NOC",
    action: "Evaluación Periódica de Reglas",
    date: "Hace 30 minutos",
    status: "Correcto",
  },
  {
    username: "superadmin",
    module: "Usuarios",
    action: "Actualización de Permisos Rol",
    date: "Hace 1 hora",
    status: "Correcto",
  },
];

export default function RecentAuditActivity({ logs = [] }) {
  const displayLogs = logs && logs.length > 0 ? logs.slice(0, 5) : DEFAULT_EVENTS;
  const auditEntries = displayLogs.map((log, idx) => {
    const rawStatus = (log.status )//.toLowerCase();
    const isOk = log.status
    return {
      key: idx,
      username: log.username || "Usuario",
      module: log.module || log.modulo || "Sistema",
      action: log.action || log.accion || "Transacción",
      date: log.date || log.createdAt || log.fecha || "Reciente",
      isOk,
      status: log.status ?'Correcto':'Incorrecto',
    };
  });

  return (
    <div className="sad-card">
      <div className="sad-card-header">
        <span className="sad-card-title">
          <FaShieldAlt className="text-primary" /> Trazabilidad y Seguridad en Tiempo Real
        </span>
        <Link to="/audits" className="sad-card-badge" style={{ display: "inline-flex", alignItems: "center", gap: "5px" }}>
          <span>Auditoría Forense</span>
          <FaExternalLinkAlt style={{ fontSize: "0.65rem" }} />
        </Link>
      </div>

      <div className="sad-audit-table-scroll">
        <table className="sad-audit-table">
          <thead>
            <tr>
              <th>Usuario</th>
              <th>Módulo</th>
              <th>Acción Realizada</th>
              <th>Hora / Fecha</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            {auditEntries.map((entry) => (
                <tr key={entry.key}>
                  <td>
                    <div className="sad-audit-user">
                      <div className="sad-user-avatar-sm">
                        {entry.username.substring(0, 2).toUpperCase()}
                      </div>
                      <span>{entry.username}</span>
                    </div>
                  </td>
                  <td>
                    <span className="sad-badge info">{entry.module}</span>
                  </td>
                  <td>{entry.action}</td>
                  <td style={{ color: "#64748B", fontSize: "0.78rem" }}>
                    {entry.date}
                  </td>
                  <td>
                    <span className={`sad-badge ${entry.isOk ? "success" : "danger"}`}>
                      {entry.isOk ? <FaCheckCircle /> : <FaExclamationCircle />}
                      {entry.status}
                    </span>
                  </td>
                </tr>
            ))}
          </tbody>
        </table>
      </div>

      <ul className="sad-audit-mobile-list" aria-label="Eventos recientes de auditoría">
        {auditEntries.map((entry) => (
          <li key={entry.key} className="sad-audit-mobile-item">
            <details className="sad-audit-mobile-card">
              <summary className="sad-audit-mobile-summary">
                <span className="sad-audit-mobile-action">{entry.action}</span>
                <span className={`sad-badge ${entry.isOk ? "success" : "danger"}`}>
                  {entry.isOk ? <FaCheckCircle aria-hidden="true" /> : <FaExclamationCircle aria-hidden="true" />}
                  {entry.status}
                </span>
              </summary>
              <dl className="sad-audit-mobile-details">
                <div>
                  <dt>Usuario</dt>
                  <dd>{entry.username}</dd>
                </div>
                <div>
                  <dt>Módulo</dt>
                  <dd>{entry.module}</dd>
                </div>
                <div>
                  <dt>Fecha y hora</dt>
                  <dd>{entry.date}</dd>
                </div>
              </dl>
            </details>
          </li>
        ))}
      </ul>
    </div>
  );
}
